/* Wamory — country-aware language suggestion.
   Loaded only on neutral (Arabic, no /en prefix) storefront URLs. It never redirects on its own:
   a visitor from a non-Arabic-speaking country whose browser is not set to Arabic gets one small,
   dismissible offer to view the same page in English. Order of precedence:
   1. explicit choice in the URL (?lang=…, written by the language switch)  -> remembered, nothing shown
   2. saved choice (localStorage wm-lang-pref)                               -> respected, nothing shown
   3. detected country + browser language                                     -> offer English, or nothing
   The current path, query string (UTM, fbclid, gclid, ttclid, variant, discount) and hash are kept. */
(function () {
  var KEY = 'wm-lang-pref';
  var ARABIC_COUNTRIES = ['AE', 'SA', 'KW', 'QA', 'BH', 'OM', 'JO', 'EG', 'IQ', 'LB', 'SY', 'YE', 'PS', 'LY', 'TN', 'DZ', 'MA', 'SD', 'MR', 'DJ', 'SO', 'KM'];
  function read() { try { return localStorage.getItem(KEY); } catch (_) { return null; } }
  function save(value) { try { localStorage.setItem(KEY, value); } catch (_) { /* storage unavailable */ } }

  var requested = new URLSearchParams(location.search).get('lang');
  if (requested === 'ar' || requested === 'en') { save(requested); return; }
  if (document.documentElement.lang !== 'ar') return;
  var saved = read();
  if (saved === 'ar') return;
  if (/^\/(cart|checkout|account|apps|tools|challenge)(\/|$)/.test(location.pathname)) return;
  if (saved === 'en') { show(); return; }
  if (navigator.webdriver || /bot|crawl|spider|slurp|preview|lighthouse|headless/i.test(navigator.userAgent)) return;
  var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
  if (languages.some(function (l) { return /^ar\b/i.test(l); })) return;

  function switchToEnglish() {
    save('en');
    var form = document.getElementById('WamoryLocalizationForm');
    var select = form && form.querySelector('[name="language_code"], [name="locale_code"]');
    var destination = new URL(location.href);
    destination.searchParams.set('lang', 'en');
    var returnTo = form && form.querySelector('[name="return_to"]');
    if (form && select && returnTo && Array.from(select.options).some(function (o) { return o.value === 'en'; })) {
      returnTo.value = destination.pathname + destination.search + destination.hash;
      select.value = 'en';
      form.submit();
      return;
    }
    location.assign('/en' + (destination.pathname === '/' ? '' : destination.pathname) + destination.search + destination.hash);
  }

  function show() {
    if (document.getElementById('wm-lang-suggest')) return;
    var bar = document.createElement('div');
    bar.id = 'wm-lang-suggest';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Language');
    bar.setAttribute('dir', 'ltr');
    bar.setAttribute('lang', 'en');
    bar.style.cssText = 'position:fixed;left:50%;transform:translateX(-50%);bottom:calc(84px + env(safe-area-inset-bottom,0px));z-index:900;display:flex;align-items:center;gap:10px;max-width:calc(100vw - 24px);padding:10px 12px 10px 16px;border-radius:999px;background:#fffdf9;color:#5d463d;border:1px solid #ead9d2;box-shadow:0 8px 28px rgba(93,70,61,.16);font:500 14px/1.3 system-ui,-apple-system,"Segoe UI",sans-serif';
    var label = document.createElement('span');
    label.textContent = 'Prefer to shop in English?';
    var yes = document.createElement('button');
    yes.type = 'button';
    yes.textContent = 'View in English';
    yes.style.cssText = 'border:0;border-radius:999px;padding:8px 14px;background:#bc6b80;color:#fff;font:inherit;font-weight:700;cursor:pointer;white-space:nowrap';
    var no = document.createElement('button');
    no.type = 'button';
    no.setAttribute('aria-label', 'Keep Arabic');
    no.textContent = '×';
    no.style.cssText = 'border:0;background:transparent;color:inherit;font-size:20px;line-height:1;padding:4px 8px;cursor:pointer';
    yes.addEventListener('click', switchToEnglish);
    no.addEventListener('click', function () { save('ar'); bar.remove(); });
    bar.append(label, yes, no);
    document.body.appendChild(bar);
  }

  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!country || ARABIC_COUNTRIES.indexOf(String(country).toUpperCase()) !== -1) return;
      show();
    })
    .catch(function () { /* detection unavailable: stay on the default language */ });
})();
